import { gql } from "@apollo/client";

const GET_CLIENT_RISK_SCORE = gql`
  query getClient($identifier: String!, $isHandled: Boolean) {
    client(clientIdentifier: $identifier) {
      id
      name
      riskScore {
        current {
          created
          id
          latestUpdatedAt
          previousTotalScore
          totalScore
          manualRiskScore {
            id
            scoreModifier
            validTo
            comment {
              id
              content
              createdAt
              createdByUser {
                id
                firstName
                lastName
              }
            }
          }
          riskScoreClass
          rules {
            id
            description
            dominantRule
            score
            title
            ruleResult
            type
            comments {
              items {
                id
                content
                createdAt
                createdByUser {
                  id
                  firstName
                  lastName
                }
              }
            }
            parameterExclusionOptions {
              canSetExpirationDate
              latestAllowedExpirationDate
            }
            parameters {
              id
              title
              information {
                description
              }
              exclusions {
                id
                activeUntil
                activeUntilFurtherNotice
                createdAt
                isActive
              }
              resources {
                ... on ClientLinkModel {
                  identifier
                  description
                }
                ... on CompanyLinkModel {
                  identifier
                  description
                }
                ... on InvoiceLinkModel {
                  identifier
                  description
                }
                ... on IObjectLink {
                  identifier
                  description
                }
                ... on PersonLinkModel {
                  identifier
                  description
                }
              }
            }
          }
        }
        currentManualRiskScore {
          id
          scoreModifier
          validTo
          comment {
            id
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
          }
        }
        exclusionHistory {
          id
          activeUntil
          activeUntilFurtherNotice
          comment {
            id
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
          }
          createdAt
          createdByUser {
            id
            firstName
            lastName
          }
          description
          referenceIdentifier
          title
        }
        activeExclusions {
          id
          activeUntil
          activeUntilFurtherNotice
          comment {
            id
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
          }
          createdAt
          createdByUser {
            id
            firstName
            lastName
          }
          description
          referenceIdentifier
          title
          ruleType
        }
      }
      monitoringEvents(isHandled: $isHandled) {
        totalCount
        items {
          id
          handled
        }
      }
    }
  }
`;

export default GET_CLIENT_RISK_SCORE;
